import {createContext} from 'react';

import type {MediaController} from '@pexip/media';

export const UserMediaContext = createContext<undefined | MediaController>(
    undefined,
);
